<div class="min-h-screen bg-gray-100">
    <router-outlet></router-outlet>
</div>